import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "ff_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, quantity = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id);
      if (idx > -1) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: Number((next[idx].quantity + quantity).toFixed(2)) };
        return next;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          unit: product.unit,
          price: product.price,
          image_url: product.image_url,
          quantity,
        },
      ];
    });
  };

  const setQuantity = (product_id, quantity) => {
    setItems((prev) =>
      prev.map((i) => {
        if (i.product_id !== product_id) return i;
        const raw = Number(quantity);
        if (Number.isNaN(raw) || raw < 0) return { ...i, quantity: 0 };
        // For non-kg units enforce integer
        const q = i.unit === "kg" ? Math.round(raw * 10) / 10 : Math.max(0, Math.round(raw));
        return { ...i, quantity: q };
      })
    );
  };

  const remove = (product_id) => {
    setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  };

  const clear = () => setItems([]);

  const count = items.reduce((a, i) => a + Number(i.quantity || 0), 0);
  const subtotal = items.reduce((a, i) => a + i.price * Number(i.quantity || 0), 0);

  return (
    <CartContext.Provider value={{ items, add, setQuantity, remove, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
